export default __webpack_public_path__ + "static/thumbnailBg-e66dccb0a32971f959f9bf9fa42e1391.png";